module.exports = __webpack_public_path__ + "static/img/product07-2.f68aba8c.png";